import { ACTION_TYPES, DEFAULT_LOADING_STATES } from '@constants';

const DEFAULT_STATES = {
  ...DEFAULT_LOADING_STATES,
  statistical: {},
};

export default (
  state = DEFAULT_STATES,
  action: { type: string; payload: string }
) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.CLEAR_STATISTICAL: {
      return { ...state, statistical: {} };
    }
    case ACTION_TYPES.SET_STATISTICAL_ACTION_LOADING: {
      return {
        ...state,
        isActionLoading: payload,
      };
    }
    case ACTION_TYPES.SET_STATISTICAL_GET_LOADING: {
      return {
        ...state,
        isGetLoading: payload,
      };
    }
    case ACTION_TYPES.FETCH_STATISTICAL_SUCCESS:
      return {
        ...state,
        requestIsSuccess: true,
        requestHasError: false,
        isGetLoading: false,
        statistical: payload,
      };
    case ACTION_TYPES.FETCH_STATISTICAL_FAILURE:
      return {
        ...state,
        requestHasError: true,
        requestIsSuccess: false,
        isGetLoading: false,
      };
    case ACTION_TYPES.UPDATE_STATISTICAL_SUCCESS:
      return {
        ...state,
        requestIsSuccess: true,
        requestHasError: false,
        isActionLoading: false,
        isGetLoading: false,
        statistical: payload,
      };
    case ACTION_TYPES.UPDATE_STATISTICAL_FAILURE:
      return {
        ...state,
        requestHasError: true,
        requestIsSuccess: false,
        isActionLoading: false,
        isGetLoading: false,
      };
    case ACTION_TYPES.CREATE_STATISTICAL_SUCCES:
      return {
        ...state,
        requestIsSuccess: true,
        requestHasError: false,
        isActionLoading: false,
        isGetLoading: false,
        statistical: payload,
      };
    case ACTION_TYPES.CREATE_STATISTICAL_FAILURE:
      return {
        ...state,
        requestHasError: true,
        requestIsSuccess: false,
        isActionLoading: false,
        isGetLoading: false,
      };
    default:
      return state;
  }
};
